import { useEffect } from "react";
import Lenis from "lenis";
import { useLocation } from "react-router-dom";

let lenisInstance = null;
export const getLenis = () => lenisInstance;

export function useLenis() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.085, wheelMultiplier: 0.95, smoothWheel: true, autoRaf: true });
    lenisInstance = lenis;
    return () => { lenis.destroy(); lenisInstance = null; };
  }, []);

  useEffect(() => {
    const target = hash ? document.querySelector(hash) : null;
    if (!target) {
      if (lenisInstance) lenisInstance.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
      return undefined;
    }
    const OFFSET = 90;
    const go = (immediate) => {
      const el = document.querySelector(hash);
      if (!el) return;
      if (lenisInstance) lenisInstance.scrollTo(el, { offset: -OFFSET, immediate });
      else window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - OFFSET, behavior: immediate ? "auto" : "smooth" });
    };
    const settled = () => {
      const el = document.querySelector(hash);
      return el && Math.abs(el.getBoundingClientRect().top - OFFSET) < 6;
    };
    const timers = [
      setTimeout(() => go(false), 80),
      ...[700, 1400, 2400].map((t) => setTimeout(() => { if (!settled()) go(true); }, t)),
    ];
    return () => timers.forEach(clearTimeout);
  }, [pathname, hash]);
}
